import { PAYMENT_V2_ENDPOINT_V1 } from "@/components/Pricing/v2/constants.pricing";
import { TPlanCurrentInterval } from "@/types/app";
import axios from "axios";

const APIURL = `${PAYMENT_V2_ENDPOINT_V1}/plan/estimate`;

export const estimatePlanIntervalChange = async ({
  token,
  interval,
  couponValue,
}: {
  token: string;
  interval: TPlanCurrentInterval;
  couponValue?: string;
}) => {
  try {
    const res = await axios.post(
      APIURL,
      {
        request_type: "estimate",
        change_to: interval,
        ...(couponValue && { coupon: couponValue }),
      },
      {
        headers: {
          Authorization: "Bearer " + token,
        },
      },
    );
    return res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
